import { fmtDate, statusCls } from "./constants";

const HEADERS = {
  "applications": ["Name", "Lane", "School / Program", "Location", "Credit?", "Portfolio?", "Submitted", "Status"],
  "school-inquiries": ["Name", "Contact", "Students", "Format", "Submitted", "Status"],
  "brand-inquiries": ["Name", "Contact", "Partnership", "Submitted", "Status"],
};

const RowCells = ({ tab, r }) => {
  if (tab === "applications") {
    return (
      <>
        <td className="p-3">{r.primary_lane}</td>
        <td className="p-3">{[r.school?.school_name, r.school?.program].filter(Boolean).join(" / ") || "—"}</td>
        <td className="p-3">{r.city_state || "—"}</td>
        <td className="p-3">{r.school?.seeking_credit ? "Yes" : "No"}</td>
        <td className="p-3">{r.creative?.portfolio_url ? "Yes" : "No"}</td>
      </>
    );
  }
  if (tab === "school-inquiries") {
    return (
      <>
        <td className="p-3">{r.contact_name}</td>
        <td className="p-3">{r.programs?.student_count || "—"}</td>
        <td className="p-3">{r.programs?.format || "—"}</td>
      </>
    );
  }
  return (
    <>
      <td className="p-3">{r.contact_name}</td>
      <td className="p-3">{(r.partnership_types || []).join(", ")}</td>
    </>
  );
};

export const ListTable = ({ tab, rows, loading, onSelect }) => (
  <div className="mt-4 overflow-x-auto border border-gold/25 bg-charcoal">
    <table className="w-full min-w-[760px]" data-testid="admin-table">
      <thead className="border-b border-gold/25 bg-onyx">
        <tr className="text-left font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-gold">
          {HEADERS[tab].map((h) => (
            <th key={h} className="p-3">{h}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.id} onClick={() => onSelect(r)} data-testid={"admin-row-" + r.id} className="cursor-pointer border-b border-silver/10 font-body text-sm text-silver transition-colors hover:bg-gold/5">
            <td className="p-3 font-bold text-cream">
              {r.full_name || r.institution_name || r.company_name}
              <br />
              <span className="font-mono text-[10px] font-normal text-silver/50">{r.email || r.contact_email}</span>
            </td>
            <RowCells tab={tab} r={r} />
            <td className="p-3 font-mono text-xs">{fmtDate(r.created_at)}</td>
            <td className="p-3">
              <span className={"border px-2 py-0.5 font-mono text-[10px] font-bold uppercase " + statusCls(r.status)}>{r.status.replace(/_/g, " ")}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    {!loading && rows.length === 0 && (
      <p className="p-10 text-center font-head text-lg font-bold uppercase text-silver/40" data-testid="admin-empty">Nothing in this lane yet.</p>
    )}
    {loading && <p className="p-10 text-center font-head text-sm font-bold uppercase text-silver/40">Loading...</p>}
  </div>
);
